import { AdminScheduledGamesScreen } from '@/screens/admin/admin-scheduled-games-screen'

export default function () {
  return <AdminScheduledGamesScreen />
}
